import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '../../@vex/layout/layout.module';
import { CustomLayoutComponent } from './custom-layout.component';

import { FooterModule } from '../../@vex/layout/footer/footer.module';

import { HeaderModule } from '../../@vex/layout/header/header.module';

@NgModule({
	imports: [CommonModule, LayoutModule, FooterModule, HeaderModule, CustomLayoutComponent],
})
export class CustomLayoutModule {}
